/**
 * Footer behavior: back-to-top button visibility + click-to-scroll.
 */

function initBackToTop() {
	const button = document.querySelector( '[data-craftis-back-to-top]' );
	if ( ! button ) {
		return;
	}

	const offset = parseInt( button.dataset.offset || '400', 10 );

	const onScroll = () => {
		button.classList.toggle( 'is-visible', window.scrollY > offset );
	};

	window.addEventListener( 'scroll', onScroll, { passive: true } );
	onScroll();

	button.addEventListener( 'click', () => {
		window.scrollTo( { top: 0, behavior: 'smooth' } );
	} );
}

document.addEventListener( 'DOMContentLoaded', initBackToTop );
